import React, { useEffect } from "react";
// import OrdersComponent from "../../features/products/Orders";
import OrdersComponent from "../../../../features/userDashboard/orders/Orders";
import Dashboard from "../../Dashboard";

function Orders() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <Dashboard>
      <OrdersComponent />
    </Dashboard>
  );
}

export default Orders;
